"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.NavigationTab = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TitleBlockZen_1 = require("./TitleBlockZen");
var NavigationTabs_module_scss_1 = __importDefault(require("./NavigationTabs.module.scss"));
var isLight = function (variant) {
    return variant !== undefined && TitleBlockZen_1.NON_REVERSED_VARIANTS.includes(variant);
};
var NavigationTab = function (props) {
    var className = (0, classnames_1["default"])(NavigationTabs_module_scss_1["default"].linkAnchor, isLight(props.variant) && NavigationTabs_module_scss_1["default"].lightBackground, props.active && NavigationTabs_module_scss_1["default"].active);
    if (props.render) {
        var Component = props.render, otherProps = __rest(props, ["render"]);
        return react_1["default"].createElement(Component, __assign({}, otherProps, { className: className }));
    }
    return (react_1["default"].createElement("a", { className: className, href: props.href, onClick: props.handleClick, id: props.id, "data-automation-id": props.automationId, "data-testid": props.automationId, "aria-current": props.active ? "page" : undefined }, props.text));
};
exports.NavigationTab = NavigationTab;
exports.NavigationTab.displayName = "NavigationTab";
//# sourceMappingURL=NavigationTabs.js.map